<canvas id="chart-canvas" baseChart class="chart__canvas" [data]="dataSet" [options]="optionsLocal" [type]="chartType" [plugins]="plugins"></canvas>
